import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import * as c from "./alertConstants";
import emojiRegex from "emoji-regex";

const Alert = ({ children, className, type, block }) => (
  <div
    className={cl("alert", className, {
      "alert--block": block,
      "alert--no-icon": emojiRegex().test(children),
      "alert--warning": type === c.WARNING,
      "alert--info": type === c.INFO,
      "alert--error": type === c.ERROR,
    })}
  >
    {children}
  </div>
);

Alert.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf([c.WARNING, c.INFO, c.ERROR]),
  block: PropTypes.bool.isRequired,
};

Alert.defaultProps = {
  children: "",
  block: false,
};

export default Alert;
